/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Oas30Schema } from '../../openapi/v3/models/Oas30Schema';
import { AbstractSchemaInhCommand } from './AbstractSchemaInhCommand';

/**
 * A command used to delete a single child schema from a parent schema.
 * @author eric.wittmann@gmail.com
 * @extends AbstractSchemaInhCommand
 * @class
 */
export class DeleteChildSchemaCommand extends AbstractSchemaInhCommand {
    public _schemaPath : NodePath;

    public _parentPath : NodePath;

    public _oldSchema : any;

    public _oldSchemaType : string;

    public constructor(schema? : any) {
        if(((schema != null && schema instanceof <any>OasSchema) || schema === null)) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldSchema===undefined) this._oldSchema = null;
            if(this._oldSchemaType===undefined) this._oldSchemaType = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldSchema===undefined) this._oldSchema = null;
            if(this._oldSchemaType===undefined) this._oldSchemaType = null;
            (() => {
                this._schemaPath = Library.createNodePath(schema);
                this._parentPath = Library.createNodePath(schema.parent());
            })();
        } else if(schema === undefined) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldSchema===undefined) this._oldSchema = null;
            if(this._oldSchemaType===undefined) this._oldSchemaType = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldSchema===undefined) this._oldSchema = null;
            if(this._oldSchemaType===undefined) this._oldSchemaType = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteChildSchemaCommand] Executing.");
        this._oldSchema = null;
        let childSchema : OasSchema = <OasSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(childSchema)) {
            return;
        }
        let schemaRemover : DeleteChildSchemaCommand.SchemaRemoverVisitor = new DeleteChildSchemaCommand.SchemaRemoverVisitor();
        Library.visitNode(childSchema, schemaRemover);
        this._oldSchema = Library.writeNode(childSchema);
        this._oldSchemaType = schemaRemover.type;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteChildSchemaCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldSchema)) {
            return;
        }
        let parent : OasSchema = <OasSchema>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let schema : OasSchema = this.createSchema(parent, this._oldSchemaType);
        Library.readNode(this._oldSchema, schema);
        let schemaAdder : DeleteChildSchemaCommand.SchemaAdderVisitor = new DeleteChildSchemaCommand.SchemaAdderVisitor();
        Library.visitNode(schema, schemaAdder);
    }
}
DeleteChildSchemaCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteChildSchemaCommand";
DeleteChildSchemaCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];



export namespace DeleteChildSchemaCommand {

    /**
     * Visitor used to remove a child schema from its parent.
     * @author eric.wittmann@gmail.com
     * @extends CombinedVisitorAdapter
     * @class
     */
    export class SchemaRemoverVisitor extends CombinedVisitorAdapter {
        public type : string;

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
         * @param {OasSchema} node
         */
        public visitAllOfSchema(node : OasSchema) {
            let parentSchema : OasSchema = <OasSchema>node.parent();
            parentSchema.removeAllOfSchema(node);
            this.type = AbstractSchemaInhCommand.TYPE_ALL_OF;
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAnyOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema)
         * @param {Oas30Schema.Oas30AnyOfSchema} node
         */
        public visitAnyOfSchema(node : Oas30Schema.Oas30AnyOfSchema) {
            let parentSchema : Oas30Schema = <Oas30Schema>node.parent();
            parentSchema.removeAnyOfSchema(node);
            this.type = AbstractSchemaInhCommand.TYPE_ANY_OF;
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitOneOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema)
         * @param {Oas30Schema.Oas30OneOfSchema} node
         */
        public visitOneOfSchema(node : Oas30Schema.Oas30OneOfSchema) {
            let parentSchema : Oas30Schema = <Oas30Schema>node.parent();
            parentSchema.removeOneOfSchema(node);
            this.type = AbstractSchemaInhCommand.TYPE_ONE_OF;
        }

        constructor() {
            super();
            if(this.type===undefined) this.type = null;
        }
    }
    SchemaRemoverVisitor["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteChildSchemaCommand.SchemaRemoverVisitor";
    SchemaRemoverVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];



    /**
     * Visitor used to add a child schema to its parent.
     * @author eric.wittmann@gmail.com
     * @extends CombinedVisitorAdapter
     * @class
     */
    export class SchemaAdderVisitor extends CombinedVisitorAdapter {
        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
         * @param {OasSchema} node
         */
        public visitAllOfSchema(node : OasSchema) {
            let parentSchema : OasSchema = <OasSchema>node.parent();
            parentSchema.addAllOfSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAnyOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema)
         * @param {Oas30Schema.Oas30AnyOfSchema} node
         */
        public visitAnyOfSchema(node : Oas30Schema.Oas30AnyOfSchema) {
            let parentSchema : Oas30Schema = <Oas30Schema>node.parent();
            parentSchema.addAnyOfSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitOneOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema)
         * @param {Oas30Schema.Oas30OneOfSchema} node
         */
        public visitOneOfSchema(node : Oas30Schema.Oas30OneOfSchema) {
            let parentSchema : Oas30Schema = <Oas30Schema>node.parent();
            parentSchema.addOneOfSchema(node);
        }

        constructor() {
            super();
        }
    }
    SchemaAdderVisitor["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteChildSchemaCommand.SchemaAdderVisitor";
    SchemaAdderVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];


}




import { MarshallCompat } from '../../compat/MarshallCompat';

